const MARQUEE_ITEMS = [
  "Facciate Condominiali",
  "Cappotto Termico",
  "Restauri Storici",
  "Cartongesso",
  "Decorativi a Calce",
  "Ristrutturazioni Chiavi in Mano",
  "Ringhiere su misura",
  "Recinzioni Moderne",
  "Cancelli Taglio Laser",
  "Arredo Industriale",
  "Impianti Fotovoltaici",
  "Tinteggiature",
];

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="marquee"
      className="bg-[#FF5A1F] py-5 border-y border-[#EA450C] overflow-hidden"
    >
      <div className="marquee flex gap-12 whitespace-nowrap">
        {items.map((t, i) => (
          <span
            key={i}
            className="text-white font-bold text-base md:text-xl tracking-tight inline-flex items-center gap-12"
          >
            {t}
            <span className="text-white/60 text-xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
